import { RequireOnly } from '@pelicargo/types';
import { FlightSegment, Quote } from '@prisma/client';

export const relevantBacklogAirports = (
  quote: RequireOnly<Quote, 'origin_airport_id' | 'destination_airport_id'> & {
    flight_path?: RequireOnly<FlightSegment, 'origin_airport_id' | 'destination_airport_id'>[];
  },
) =>
  Array.from(
    new Set(
      [
        ...(quote.flight_path?.flatMap((fp) => [fp.origin_airport_id, fp.destination_airport_id]) ?? []),
        quote.origin_airport_id,
        quote.destination_airport_id,
      ].filter((id): id is string => Boolean(id)),
    ),
  );
